const CirclePlayIcon = () => (
  <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="45.8335" cy="45.957" r="45.5" fill="white" />
    <path
      d="M67.3335 45.957L36.3335 64.457L36.3335 27.457L67.3335 45.957Z"
      fill="#F8D225"
      stroke="#F8D225"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CirclePlayIcon;
